var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlackIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E01E5A",
  d: "M2.471 11.318a1.474 1.474 0 0 0 1.47-1.471v-1.47h-1.47A1.474 1.474 0 0 0 1 9.846a1.47 1.47 0 0 0 1.47 1.47zm3.682-2.942a1.474 1.474 0 0 0-1.47 1.471v3.683c.002.811.66 1.468 1.47 1.47a1.474 1.474 0 0 0 1.47-1.47V9.846a1.474 1.474 0 0 0-1.47-1.47"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36C5F0",
  d: "M4.683 2.471a1.47 1.47 0 0 0 1.47 1.47h1.47v-1.47A1.474 1.474 0 0 0 6.154 1a1.474 1.474 0 0 0-1.47 1.47zm2.94 3.682a1.474 1.474 0 0 0-1.47-1.47H2.47A1.474 1.474 0 0 0 1 6.153c.002.812.66 1.469 1.47 1.47h3.684a1.474 1.474 0 0 0 1.47-1.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2EB67D",
  d: "M9.847 7.624a1.474 1.474 0 0 0 1.47-1.47V2.47A1.474 1.474 0 0 0 9.848 1a1.474 1.474 0 0 0-1.47 1.47v3.684c.002.81.659 1.468 1.47 1.47zm3.682-2.941a1.474 1.474 0 0 0-1.47 1.47v1.47h1.47A1.474 1.474 0 0 0 15 6.154a1.474 1.474 0 0 0-1.47-1.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECB22E",
  d: "M8.377 9.847a1.473 1.473 0 0 0 1.47 1.47h3.683A1.474 1.474 0 0 0 15 9.848a1.474 1.474 0 0 0-1.47-1.47H9.847a1.474 1.474 0 0 0-1.47 1.47zm2.94 3.682a1.474 1.474 0 0 0-1.47-1.47h-1.47v1.47a1.47 1.47 0 0 0 1.47 1.47 1.474 1.474 0 0 0 1.47-1.47"
}))));
export { SvgSlackIcon as ReactComponent };
export default __webpack_public_path__ + "8685d03e70421e775a62b179c3d58b9e.svg";